<template>
  <nav class="nav">
    <!-- Brand: PAYTON.kz with accent suffix -->
    <a href="#/users" class="brand">
      PAYTON<em>.KZ</em>
    </a>

    <div class="nav-right">
      <!-- Language switcher (i18n) -->
      <b-dropdown
        class="nav-lang-dd"
        toggle-class="nav-lang"
        variant="link"
        no-caret
        right
      >
        <template #button-content>
          {{ ($i18n.locale() || 'РУС').toUpperCase() }}
        </template>
        <b-dropdown-item
          v-for="locale in $i18n.locales()"
          :key="'i18n-' + locale"
          v-if="$i18n.locale() !== locale"
          @click="$i18n.set(locale)"
        >
          {{ locale.toUpperCase() }}
        </b-dropdown-item>
      </b-dropdown>

      <!-- Notifications (placeholder, not wired yet) — временно скрыто -->
      <button v-if="false" class="nav-notif" type="button" aria-label="Уведомления">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
          <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
        </svg>
        <span class="nav-notif-dot" />
      </button>

      <!-- User dropdown -->
      <b-dropdown
        class="nav-user-dd"
        toggle-class="nav-user"
        variant="link"
        no-caret
        right
      >
        <template #button-content>
          <span class="nav-avatar">{{ userInitials }}</span>
          <span class="nav-uname">{{ userDisplayName }}</span>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="m6 9 6 6 6-6"/>
          </svg>
        </template>
        <b-dropdown-item href="/#/security">Безопасность (2FA)</b-dropdown-item>
        <b-dropdown-divider />
        <b-dropdown-item @click="logOut">{{ $t('logOut') }}</b-dropdown-item>
      </b-dropdown>
    </div>
  </nav>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'AppHeader',
  computed: {
    ...mapState(['loginedUser']),
    userDisplayName() {
      const u = this.loginedUser || {}
      if (u.userName) return u.userName
      const role = (u.userRoles && u.userRoles.length) ? u.userRoles[0].name : ''
      return role || 'Администратор'
    },
    userInitials() {
      const name = this.userDisplayName || 'АД'
      const cleaned = name.replace(/[^A-Za-zА-Яа-яЁё ]/g, '').trim()
      if (!cleaned) return 'АД'
      const parts = cleaned.split(/\s+/)
      const a = parts[0] && parts[0][0] ? parts[0][0] : ''
      const b = parts[1] && parts[1][0] ? parts[1][0] : ''
      return ((a + b) || a || 'АД').toUpperCase()
    },
  },
  methods: {
    ...mapActions(['logoutSystem']),
    logOut() {
      window.localStorage.removeItem('authUser')
      window.localStorage.clear()
      this.logoutSystem()
      this.$router.push({ name: 'Login' })
    },
  },
  created() {
    const roles = (this.loginedUser && this.loginedUser.userRoles) || []
    const allowed = ['ADMIN', 'MANAGER', 'OPERATOR', 'MLRO', 'COMPILANCE']
    const has = roles.some(r => allowed.includes(r.name))
    if (!has) window.location.href = '/#/login'
  },
}
</script>

<style scoped>
.nav {
  height: var(--nav-h);
  background: #fff;
  border-bottom: 1px solid var(--c-border);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  position: sticky;
  top: 0;
  z-index: 200;
  box-shadow: var(--shadow-1);
}

.brand {
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 0.04em;
  color: var(--c-text);
  text-decoration: none;
}
.brand em { color: var(--c-accent); font-style: normal; }

.nav-right {
  display: flex;
  align-items: center;
  gap: 14px;
}

/* Language pill */
.nav-lang-dd >>> .nav-lang {
  font-size: 12px !important;
  color: var(--c-text-3) !important;
  font-weight: 600 !important;
  letter-spacing: 0.07em;
  padding: 6px 11px !important;
  border-radius: 6px;
  border: 1px solid var(--c-border);
  background: #fff;
  box-shadow: none !important;
  text-decoration: none !important;
}
.nav-lang-dd >>> .nav-lang:hover { background: var(--c-soft); }

/* Notif bell */
.nav-notif {
  width: 34px; height: 34px;
  border-radius: var(--r-md);
  border: 1px solid var(--c-border);
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--c-text-3);
  position: relative;
  cursor: pointer;
}
.nav-notif:hover { background: var(--c-soft); }
.nav-notif-dot {
  position: absolute;
  top: 7px; right: 7px;
  width: 6px; height: 6px;
  border-radius: 50%;
  background: #EF4444;
  border: 1.5px solid #fff;
}

/* User chip */
.nav-user-dd >>> .nav-user {
  display: flex !important;
  align-items: center;
  gap: 9px;
  padding: 5px 12px 5px 5px !important;
  border-radius: var(--r-md);
  border: 1px solid var(--c-border);
  background: #fff;
  cursor: pointer;
  color: var(--c-text-2) !important;
  text-decoration: none !important;
  box-shadow: none !important;
}
.nav-user-dd >>> .nav-user:hover { background: var(--c-soft); }
.nav-avatar {
  width: 28px; height: 28px;
  border-radius: var(--r-sm);
  background: var(--c-accent);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  color: #fff;
}
.nav-uname {
  font-size: 13px;
  color: var(--c-text-2);
  font-weight: 600;
}

/* Dropdown menus — soft cards */
.nav-lang-dd >>> .dropdown-menu,
.nav-user-dd >>> .dropdown-menu {
  border: 1px solid var(--c-border);
  border-radius: var(--r-lg);
  box-shadow: var(--shadow-3);
  margin-top: 6px;
  padding: 6px;
  font-size: 13px;
}
.nav-lang-dd >>> .dropdown-item,
.nav-user-dd >>> .dropdown-item {
  border-radius: 7px;
  padding: 8px 11px;
  font-weight: 600;
  color: var(--c-text-2);
}
.nav-lang-dd >>> .dropdown-item:hover,
.nav-user-dd >>> .dropdown-item:hover { background: var(--c-soft); color: var(--c-text); }
</style>
